import { filterBlank } from '@dte/otw-utils-core/src/lists/filterEmpty';
import { mergeArrays } from '@dte/otw-utils-core/src/lists/mergeArrays';
import { WebEnvironment } from './WebEnvironment';

const webEnv = process.env['NEXT_PUBLIC_WEB_ENV'] as WebEnvironment;
export const isProd = webEnv === WebEnvironment.Prod;

export const ClientBuildDate = process.env['NEXT_PUBLIC_CLIENT_BUILD_DATE'] ?? '';

if (!isProd) {
	console.log('build environment: ', process.env.NODE_ENV);
	console.log('build date: ', ClientBuildDate);
	console.log('web environment: ', webEnv);
}

export function pageTitle(parts?: Array<string | undefined>): string {
	let titleParts = ['DTE Outage'];

	titleParts = mergeArrays(titleParts, parts);
	titleParts = filterBlank(titleParts);

	return titleParts.join(' - ');
}
